import { DELETE_TRC_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const deleteTRCDocumentAPI = async (id: string): Promise<any> => {
    const res = await axios.delete(`${DELETE_TRC_API}/${id}`);
};
